module.exports = __webpack_public_path__ + "static/media/default-company.a1b57740.jpg";